<div style="display: flex;
align-items: center;
gap: 8px;
align-self: stretch;">
  <div [class.active-step]="currentStep >= 1" class="progress-indicator-step"></div>
  <div [class.active-step]="currentStep >= 2" class="progress-indicator-step"></div>
  <div [class.active-step]="currentStep >= 3" class="progress-indicator-step"></div>
  <div [class.active-step]="currentStep >= 4" class="progress-indicator-step"></div>
  <div [class.active-step]="currentStep >= 5" class="progress-indicator-step"></div>
  <div [class.active-step]="currentStep >= 6" class="progress-indicator-step"></div>
</div>
